<div class="row m-0 p-0">
	<div class="col-12 mt-3">
		<mat-card class="schedule-card">
			<h5 class="mb-1"><mat-icon class="align-middle">schedule</mat-icon> Automatic monthly run</h5>
			<p class="text-muted mb-3">The server checks this schedule every night and generates the batch on the chosen day.</p>

			<div class="d-flex flex-wrap align-items-center" style="gap:1.5rem">
				<mat-slide-toggle [(ngModel)]="schedule.enabled" color="primary">Enabled</mat-slide-toggle>

				<mat-form-field appearance="fill" style="width:130px">
					<mat-label>Day of month</mat-label>
					<mat-select [(ngModel)]="schedule.day">
						<mat-option *ngFor="let d of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28]" [value]="d">{{ d }}</mat-option>
					</mat-select>
				</mat-form-field>

				<mat-checkbox [(ngModel)]="schedule.printonly" color="primary">Printed-statement customers only</mat-checkbox>
				<mat-checkbox [(ngModel)]="includeCredits" color="primary">Include credit balances</mat-checkbox>
			</div>

			<div class="mt-3">
				<button mat-raised-button color="primary" (click)="saveSchedule()" [disabled]="savingSchedule">
					<mat-icon>save</mat-icon> Save schedule
				</button>
				<button mat-raised-button color="accent" class="ml-2" (click)="runNow()" [disabled]="running">
					<mat-icon>play_arrow</mat-icon>
					<span *ngIf="!running"> Run now</span>
					<span *ngIf="running"> Running&hellip;</span>
				</button>
			</div>
		</mat-card>
	</div>
</div>

<div class="row m-0 p-0">
	<div class="col-12 mt-3">
		<button mat-raised-button color="accent" (click)="load()" [disabled]="loading">
			<mat-icon>refresh</mat-icon> Refresh
		</button>
		<span class="ml-2 text-muted" *ngIf="loading">Loading&hellip;</span>
	</div>
</div>

<div class="row m-0 p-0">
	<div class="col-12">
		<p class="text-muted mt-2 mb-2">
			Automated monthly statement batches (generated 12:00am on the 25th). Download the PDF to print and mail.
		</p>

		<div class="table w-100">
			<table class="table table-striped table-fixed">
				<thead>
					<tr>
						<th>Generated</th>
						<th>Cut-off</th>
						<th>Due</th>
						<th>Customer Range</th>
						<th class="text-right">Customers</th>
						<th class="text-right">Debit</th>
						<th class="text-right">Credit</th>
						<th class="text-right">Size</th>
						<th>Status</th>
						<th class="text-right">Print</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let a of archives">
						<td>{{ a.date_added | date:'medium' }}</td>
						<td>{{ a.run_date | date }}</td>
						<td>{{ a.date_due | date }}</td>
						<td>{{ a.debtor_start }} &ndash; {{ a.debtor_end }}</td>
						<td class="text-right">{{ a.customer_count }}</td>
						<td class="text-right">{{ a.debit_count }}</td>
						<td class="text-right">{{ a.credit_count }}</td>
						<td class="text-right">{{ fileSize(a.filesize) }}</td>
						<td>
							<span class="badge" [ngClass]="a.status === 'complete' ? 'badge-success' : 'badge-danger'">{{ a.status }}</span>
						</td>
						<td class="text-right">
							<button mat-raised-button color="primary" (click)="download(a)"
								[disabled]="a.status !== 'complete' || downloadingId === a.id">
								<mat-icon>picture_as_pdf</mat-icon>
								<span *ngIf="downloadingId !== a.id"> PDF</span>
								<span *ngIf="downloadingId === a.id"> &hellip;</span>
							</button>
						</td>
					</tr>
					<tr *ngIf="!loading && archives.length === 0">
						<td colspan="10" class="text-center text-muted p-4">No archived statement runs yet.</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>
